$shm_showcase_demo_period $mol_list
	rows /
		<= Input $shm_period
			period_str? => period_str?
		<= Selected $mol_text
			text <= period_str
